import React, {useEffect} from 'react';
import './lisenstitel.scss';
import i18n from '../../utilities/i18n';
import {Breadcrumbs} from '../breadcrumbs/breadcrumbs';
import LisensRegistrering from '../lisensregistrering/lisensregistrering';
import {env_vars} from '../../utilities/load-env';
import {useHistory} from 'react-router-dom';
import {JegerwebApiService} from '../../services/api-service/jegerweb-api-service';
import {erIkkeJeger} from '../../utilities/jegernotfound';
import {useLisensContext} from '../lisenscontext/lisenscontext';
import {SessionManager} from '../../utilities/session-management/session-manager';

const LisensTitel = () => {
  const history = useHistory();
  const [data,setData] = useLisensContext();

  const caughtError = (err) => {
    history.push(history.location.pathname + '/internalservererror');
    console.error('Nettverksfeil: Vi har problemer med å koble til. Prøv igjen senere', err);
    throw  err;
  };

  function isBirthDateUnder18(day, month, year) {
    return new Date(parseInt(year,10) + 18, month - 1, day) <= new Date();
  }

  const updatePageData = async () =>{
    let jegernr = '';
    let lisenser = [];
    let jaktaar = '';

    let pageVariabels = {
      isUtenlandsk: null,
      fodselsDag: '',
      fodselsMnd: '',
      fodselsaar: '',
      isSvartelistet: false,
      hasPaidFee: true
    };


    await JegerwebApiService.get('/jeger/:sessiontype/:lang')
      .then(response => {
        jegernr = response.data.jegernr;
        jaktaar = response.data.lisensJaktaar;
        pageVariabels = {
          ...pageVariabels,
          utenlandsk: history.location.pathname.includes('utenlandsk'),
          fodselsaar: response.data.jeger.fodselsaar,
          isSvartelistet: response.data.lisensjegerSvartelistet
        };
      }).catch(err => {
        if (erIkkeJeger(err.message)) {
          history.push(history.location.pathname + '/varsel');
          console.error('Nettverksfeil: Vi har problemer med å koble til. Prøv igjen senere', err);
          throw  err;
        } else if (err) {
          caughtError(err);
        }
      });

    await JegerwebApiService.get('/jeger/:sessiontype/betalingsinfo/:lang')
      .then(response => {
        if (['not paid','ikke betalt', null].includes( Object.values(response.data)[0].betalt_dato.toLowerCase())) {
          pageVariabels = {
            ...pageVariabels,
            hasPaidFee: false
          };
        }
      }).catch(err => {
        caughtError(err);
      });

    if (history.location.pathname.includes('utenlandsk')) {
      pageVariabels = {
        ...pageVariabels,
        fodselsDag: SessionManager.session.userInfo.birthdate.substring(0,2),
        fodselsMnd: SessionManager.session.userInfo.birthdate.substring(2,4)
      };
    } else {
      await JegerwebApiService.get('/jeger/:sessiontype/fnr').then(response =>{
        pageVariabels = {
          ...pageVariabels,
          fodselsDag: response.data.toString().substring(0,2),
          fodselsMnd: response.data.toString().substring(2,4)
        };
      });
    }


    if (data.jegernr != null) {
      await JegerwebApiService.get('/lisensjeger/:sessiontype/')
        .then(response => {
          lisenser = response.data;
          setData({jegernr,lisenser,jaktaar});
        }).catch(err => {
          caughtError(err);
        });
    }

    if (pageVariabels.isSvartelistet && !pageVariabels.isUtenlandsk ) {
      history.push(history.location.pathname + '/ugyldig');
    } else if (!isBirthDateUnder18(pageVariabels.fodselsDag,pageVariabels.fodselsMnd,pageVariabels.fodselsaar) ) {
      history.push(history.location.pathname + '/umyndig');
    } else if (!pageVariabels.hasPaidFee) {
      history.push(history.location.pathname + '/ikkebetalt');
    }
  };




  useEffect(() =>{
    updatePageData().catch(console.error);
    // eslint-disable-next-line
  },[]);


  return (
    <div className="container">
      <article className='pagetitle'>
        <Breadcrumbs crumbKey="lisensjeger" title={i18n.t('felles:lisensjeger')}/>
        <h1 id='title'>{i18n.t('titel:hovedTitel')}</h1>
        <h2>{i18n.t('titel:subTitel')}</h2>
      </article>
      <article className='informationContent'>
        <p>{i18n.t('titel:info1')}</p>
        <span>{i18n.t('titel:info2')}
          <a href={env_vars.PERSONVERN_URL} className='normal-br-link'>{i18n.t('titel:personvern')}</a>
          {i18n.t('titel:info3')}
        </span>
      </article>
      <LisensRegistrering getLisensData={updatePageData}/>
    </div>
  );
};
export default LisensTitel;
